module.exports = __webpack_public_path__ + "img/logo.92e1573e.png";